/* global Linear Quad */
import merge from 'lodash/merge';
import clone from 'lodash/clone';
import fluxDefaults from './defaults';

module.exports = merge(clone(fluxDefaults, true), {
    // particleScale: 0.6,
    initialTicks: 100,
    walls: [
        // wall top
        {
            width: '82%',
            height: 20,
            x: '7%',
            y: '-25%',
        },
        // wall left
        {
            width: 20,
            height: '60%',
            x: '15%',
            y: '-25%',
            angle: 10,
        },
        // wall right
        {
            width: 20,
            height: '60%',
            x: '81%',
            y: '-25%',
            angle: -10,
        },
        // bucket left
        {
            width: '62%',
            height: 20,
            x: '-8%',
            y: '40%',
            angle: 45,
        },
        // bucket right
        {
            width: '64%',
            height: 20,
            x: '45%',
            y: '40%',
            angle: -45,
        },
        // bucket pipe top - top
        {
            width: '102%',
            height: 20,
            x: '-40%',
            y: '52%',
        },
        // bucket pipe top - bottom
        {
            width: '59%',
            height: 20,
            x: '-10%',
            y: '58%',
        },
        // bucket pipe left - left
        {
            width: 20,
            height: '26%',
            x: '-40%',
            y: '54%',
        },
        // bucket pipe left - right
        {
            width: 20,
            height: '17%',
            x: '-10%',
            y: '58%',
        },
        // bucket pipe right - left
        {
            width: 20,
            height: '13%',
            x: '45%',
            y: '58%',
        },
        // bucket pipe right - right
        {
            width: 20,
            height: '17%',
            x: '58%',
            y: '54%',
        },
        // bucket pipe bottom - top
        {
            width: '54%',
            height: 20,
            x: '-10%',
            y: '73%',
        },
        // bucket pipe bottom - bottom
        {
            width: '90%',
            height: 20,
            x: '-40%',
            y: '79%',
        },
        // bucket pipe corner bottom 1
        {
            width: '16%',
            height: 20,
            x: '40%',
            y: '78%',
            angle: -25,
        },
        // bucket pipe corner bottom 2
        {
            width: '14%',
            height: 20,
            x: '50%',
            y: '73%',
            angle: -65,
        },
        // bucket pipe corner bottom 3
        {
            width: '10%',
            height: 20,
            x: '40%',
            y: '71%',
            angle: -60,
        },
        // bucket pipe corner top
        {
            width: '10%',
            height: 20,
            x: '53%',
            y: '54%',
            angle: 45,
        },
    ],
    movingWalls: [
        // bucket plug
        {
            width: '60%',
            height: 20,
            x: '20%',
            y: '52%',
            tween: {
                y: '40%',
                duration: 4,
                ease: Linear.easeNone,
                repeat: 0,
                name: 'bucketHolder',
                paused: true,
                loop: false,
            },
        },
        // bucket pipe pump bottom 1
        {
            width: 20,
            height: '20%',
            x: '2%',
            y: '70%',
            angle: -45,
            tween: {
                x: '152%',
                y: '52%',
                duration: 1,
                ease: Linear.easeNone,
                repeat: 3,
                name: 'bucketPump',
                paused: true,
            },
        },
        // bucket pipe pump bottom 2
        {
            width: 20,
            height: '20%',
            x: '-40%',
            y: '70%',
            angle: -45,
            tween: {
                x: '100%',
                y: '52%',
                duration: 1,
                ease: Linear.easeNone,
                repeat: 3,
                name: 'bucketPump',
                paused: true,
            },
        },
        // bucket pipe pump bottom 3
        {
            width: 20,
            height: '20%',
            x: '-40%',
            y: '70%',
            angle: -45,
            tween: {
                x: '100%',
                y: '52%',
                duration: 1,
                delay: 0.5,
                ease: Linear.easeNone,
                repeat: 5,
                name: 'bucketPump',
                paused: true,
            },
        },
        // bucket pipe pump top
        {
            width: 40,
            height: '6%',
            x: '66%',
            y: '53%',
            tween: {
                x: '-10%',
                duration: 1,
                delay: 0.8,
                ease: Linear.easeNone,
                repeat: 5,
                name: 'bucketPump',
                paused: true,
            },
        },
        // bucket pipe pump top floor
        {
            width: 70,
            height: 20,
            x: '60%',
            y: '58%',
            tween: {
                x: '-10%',
                duration: 1,
                delay: 0.8,
                ease: Linear.easeNone,
                repeat: 5,
                name: 'bucketPump',
                paused: true,
            },
        },
        // bucket pipe wall
        {
            width: 20,
            height: '6%',
            x: '-10%',
            y: '53%',
            tween: {
                y: '-1000%',
                duration: 7,
                ease: Quad.easeOut,
                name: 'bucketPump',
                paused: true,
            },
        },
    ],
    blobs: [
        // bucket
        {
            x: '25%',
            y: '0%',
            width: '40%',
            height: '30%',
            color: [0, 0, 0, 255],
        },
        {
            x: '70%',
            y: '0%',
            width: '5%',
            height: '10%',
            color: [255, 0, 0, 255],
        },
        {
            x: '70%',
            y: '0%',
            width: '5%',
            height: '10%',
            color: [0, 255, 0, 255],
        },
        {
            x: '70%',
            y: '0%',
            width: '5%',
            height: '10%',
            color: [0, 0, 255, 255],
        },
        // bucket pipe
        {
            x: '-35%',
            y: '55%',
            width: '15%',
            height: '19%',
            color: [0, 0, 0, 255],
        },
        {
            x: '-20%',
            y: '55%',
            width: '8%',
            height: '7%',
            color: [255, 0, 0, 255],
        },
        {
            x: '-20%',
            y: '55%',
            width: '8%',
            height: '7%',
            color: [0, 255, 0, 255],
        },
        {
            x: '-20%',
            y: '55%',
            width: '8%',
            height: '7%',
            color: [0, 0, 255, 255],
        },
    ],
});



// WEBPACK FOOTER //
// ./js/flux/bucketGuards.js